import React from "react";

export default function VideoGalleryItem(mediaObject) {
  const { code, url } = mediaObject;
  const embedUrl = `//www.youtube.com/embed/${code}`;

  return (
    <div className="strip-item video embed-responsive" key={code}>
      <iframe src={embedUrl} className="embed-responsive-item" allowFullScreen />
    </div>
  );
}
